export default __webpack_public_path__ + "static/media/stepsLOO.00174aab.png";